









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InvestmentContentGridCell extends Vue {
  @Prop() header!: string
}
